import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../Loader';
/**
 * Loader, ktery se zobrazi prez celou dostupnou zobrazovanou oblast.
 */

function LoaderFullscreen(props) {
  var debug = props.debug,
      loading = props.loading,
      rest = _objectWithoutProperties(props, ["debug", "loading"]);

  var st = debug ? {
    height: 250
  } : {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10000
  };
  return loading ? /*#__PURE__*/React.createElement("div", {
    style: _extends({
      display: 'flex'
    }, st)
  }, /*#__PURE__*/React.createElement(Loader, _extends({
    loading: true
  }, rest))) : null;
}

process.env.NODE_ENV !== "production" ? LoaderFullscreen.propTypes = {
  /**
   * Barva spinneru.
   */
  color: PropTypes.string,

  /**
   * @ignore
   */
  debug: PropTypes.bool,

  /**
   * `true` pokud nema byt zobrazn overlay pod spinnerem.
   */
  hideOverlay: PropTypes.bool,

  /**
   * `true` pokud se ma zobrazit loader.
   */
  loading: PropTypes.bool,

  /**
   * CSS barba pro pozadi overlay. Muzete pouzit i `rgba()`.
   */
  overlayColor: PropTypes.string,

  /**
   * Velikost loaderu
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(['normal', 'big', 'small']), PropTypes.number]),

  /**
   * Hrubka spinneru.
   */
  thickness: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8])
} : void 0;
LoaderFullscreen.defaultProps = {
  color: '#7e3ff2',
  debug: false,
  hideOverlay: false,
  loading: false,
  overlayColor: undefined,
  size: undefined,
  thickness: undefined
};
export default LoaderFullscreen;